import { render, staticRenderFns } from "./MarketingFormSendersListItem.vue?vue&type=template&id=13da9921&scoped=true"
import script from "./MarketingFormSendersListItem.vue?vue&type=script&lang=js"
export * from "./MarketingFormSendersListItem.vue?vue&type=script&lang=js"
import style0 from "./MarketingFormSendersListItem.vue?vue&type=style&index=0&id=13da9921&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da9921",
  null
  
)

export default component.exports